import React from "react";
import { IconProps } from "../iconslib";


export default function Arrow({className} : IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" className={className}>
      <title>Arrow icon</title>
      <g clipPath="url(#clip0_989_51967)">
        <path d="M0.5 6.75H11V5.25H0.5V6.75Z" fill="var(--svg-base)"/>
        <path d="M6.72703 1.97985C6.60533 1.82647 6.54843 1.63158 6.5685 1.43681C6.58856 1.24205 6.684 1.06285 6.83441 0.937508C6.98483 0.812163 7.17829 0.750607 7.37348 0.765993C7.56867 0.781378 7.75011 0.872483 7.87903 1.01985L12.028 5.99985L7.87903 10.9798C7.81687 11.0582 7.73967 11.1233 7.65197 11.1714C7.56427 11.2194 7.46784 11.2495 7.36836 11.2597C7.26888 11.27 7.16836 11.2602 7.0727 11.231C6.97705 11.2019 6.88819 11.1539 6.81137 11.0898C6.73454 11.0258 6.67129 10.9471 6.62535 10.8582C6.5794 10.7694 6.55168 10.6723 6.54382 10.5726C6.53596 10.4729 6.54812 10.3726 6.57959 10.2777C6.61105 10.1828 6.66118 10.0951 6.72703 10.0198L10.078 5.99985L6.72703 1.97985Z" fill="var(--svg-base)"/>
      </g>
      <defs>
      <clipPath id="clip0_989_51967">
        <rect width="12" height="12" fill="white" transform="translate(0.5)"/>
      </clipPath>
      </defs>
    </svg>
  );
}


